import { observable, action } from 'mobx';
import firebaseService from '../FirebaseService';
import Utils from '../Utils';

class RoomStore{
    @observable Rooms = [];
    @observable LoadingRooms = false;
    @action GetRooms(){
        this.LoadingRooms = true;
        firebaseService.Rooms()
                    .then((snapshot)=>{
                        this.Rooms = [];
                        snapshot.forEach((childSnapshot)=>{
                            this.Rooms.push(childSnapshot.val());
                        })
                    })
                    .catch((err)=>{  console.log(err);  Utils.Toast.Error("Unable to retrieve rooms"); })
                    .finally(()=>{ this.LoadingRooms = false;  });
    }
}
export default new RoomStore();


// WEBPACK FOOTER //
// ./src/stores/RoomStore.js